import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import {
  PhasrBehavioralProfilesComponentDataProviderFactory,
} from '../factory/PhasrBehavioralProfilesComponentDataProviderFactory';
import {
  PhasrBehavioralProfilesComponentBaseDataProvider,
} from '../dataProvider/PhasrBehavioralProfilesComponentBaseDataProvider';
import {
  GetDepartmentIdentitiesResponse,
  GetDepartmentsResponse, GetUserResourcesRecord,
  RequestPayload,
} from '../types';

export class PhasrBehavioralProfilesComponentRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PhasrBehavioralProfilesComponentDataProviderFactory;
  public dataProvider: PhasrBehavioralProfilesComponentBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PhasrBehavioralProfilesComponentDataProviderFactory(),
    });
  }

  public async getDepartments(payload: RequestPayload): Promise<GetDepartmentsResponse> {
    return this.dataProvider.getDepartments(payload);
  }

  public async getDepartmentIdentities(payload: RequestPayload): Promise<GetDepartmentIdentitiesResponse> {
    return this.dataProvider.getDepartmentIdentities(payload);
  }

  public async getUserResources(payload: RequestPayload): Promise<GetUserResourcesRecord[]> {
    return this.dataProvider.getUserResources(payload);
  }

}
